<template lang="pug">
  footer.TheFooter.the-footer
    .the-footer__container.page-container
      .the-footer__top-left-wrapper
        FormSubscribeNewsletter(v-if="isMounted && !__prerender",)
        TheFooterContacts.the-footer__contacts
      .the-footer__top-right-wrapper
        TheFooterMenu(v-bind="menu")
        TheFooterSocialLinks.the-footer__social-links
    .the-footer__bottom
      .page-container.the-footer__bottom-container
        TheFooterBottomContent
        TheFooterBottomLinks.the-footer__bottom-links
        p.the-footer__bottom-copyright.small-text AcreTrader, Inc. Copyright 2019, All rights reserved.
</template>

<script>
import { FOOTER_MENU } from 'Config/menu';
import FormSubscribeNewsletter from 'Components/FormSubscribeNewsletter/FormSubscribeNewsletter';
import DisclaimerDisclosure from 'Components/DisclaimerDisclosure/DisclaimerDisclosure';
import TheFooterMenu from './TheFooterMenu';
import TheFooterSocialLinks from './TheFooterSocialLinks';
import TheFooterContacts from './TheFooterContacts';
import TheFooterBottomContent from './TheFooterBottomContent';
import TheFooterBottomLinks from './TheFooterBottomLinks';

export default {
  name: 'TheFooter',
  components: {
    FormSubscribeNewsletter,
    TheFooterMenu,
    DisclaimerDisclosure,
    TheFooterSocialLinks,
    TheFooterContacts,
    TheFooterBottomContent,
    TheFooterBottomLinks,
  },
  data() {
    return {
      isMounted: false,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  mounted() {
    this.isMounted = true;
  },
  staticData: {
    menu: FOOTER_MENU,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.the-footer
  background-color: $ebony_clay
  padding-top: 80px
  padding-bottom: 45px
  position: relative
  z-index: 2
  @media screen and (max-width: 767px)
    padding-top: 70px
    padding-bottom: 50px
  &__top-left-wrapper
    width: 100%
    @media screen and (max-width: 1130px)
      margin-right: 30px
    @media screen and (min-width: 1001px)
      max-width: 560px
    @media screen and (max-width: 1000px)
      margin-right: 0
  &__top-right-wrapper
    width: 100%
    @media screen and (min-width: 1001px)
      max-width: 284px
  &__container
    justify-content: space-between
    align-items: flex-end
    @media screen and (max-width: 1000px)
      justify-content: center
      flex-wrap: wrap
  &__bottom
    border-top: solid 1px $text_gray
    padding-top: 45px
    margin-top: 45px
    @media screen and (max-width: 767px)
      padding-top: 50px
      margin-top: 70px
  &__bottom-container
    flex-direction: column
  &__bottom-links
    margin-top: 35px
  &__bottom-copyright
    +font(400)
    margin-bottom: 0
    margin-top: 35px
    color: $tones-gray-50
  &__contacts
    margin-top: 10px
    @media screen and (max-width: 1000px)
      margin-bottom: 50px
      margin-top: 30px
  &__social-links
    margin-top: 40px
    @media screen and (max-width: 767px)
      margin-top: 50px
</style>
